<div class="form-group">
    <label for="captcha">Captcha<span class="required">*</span></label>
    <div class="captcha-container">
      <!-- <input type="text" id="captcha" placeholder="Enter captcha" #captchaInput (blur)="verifyCaptcha(captchaInput.value)"/> -->
      <input type="text" id="captcha" placeholder="Enter captcha" #captchaInput />
      <div class="refresh-btn-container">
        <canvas #canvas width="130" height="40"></canvas>
        <button type="button" class="refresh-btn" (click)="generateCaptcha()">
            <img src="/assets/images/Buttons@2x.png" alt="Refresh Captcha" />
          </button>
      </div>
    </div>
    <div *ngIf="captchaError" class="error-message captcha-error">
      Incorrect captcha.
    </div>
    <!-- <button (click)="verifyCaptcha(captchaInput.value)">Verify</button> -->
  </div>
